import React, { useState, useEffect } from 'react'
import { Card, CardContent, CardHeader, makeStyles, Typography, Button, CardActions } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'

import { ChargeAccountDialog, CreditAccountDialog } from '../../Dialogs'

import { getTransactions, getBalances } from '../../../actions/households/households.actions'

const useStyles = makeStyles((theme) => ({
	card: {
		borderRadius: 6,
		backgroundColor: '#F3F3F3'
	},
	balancesWrapper: {
		display: 'flex',
		alignItems: 'center',
		'& > div': {
			width: '33%'
		}
	}
}))

const AccountBalanceCard = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const selected = useSelector((state) => state.specific.households.selected)

	let { household } = props
	const [balances, setBalances] = useState(null)
	const [isChargeAccountDialogShown, setIsChargeAccountDialogShown] = useState(false)
	const [isCreditAccountDialogShown, setIsCreditAccountDialogShown] = useState(false)
	const [credit, setCredit] = useState(0)

	useEffect(() => {
		if (household) {
			let cred = (household.credit || 0) + (household.giftcard_balance || 0)
			setCredit(cred || 0)
			if (household.balances) {
				setBalances(household.balances)
			}
		}
	}, [household])

	useEffect(() => {
		if (selected && selected._id && (!isChargeAccountDialogShown || !isCreditAccountDialogShown)) {
			dispatch(getBalances(selected._id))
			dispatch(getTransactions(selected._id))
		}
	}, [isChargeAccountDialogShown, isCreditAccountDialogShown])

	return (
		<div>
			<Card className={classes.card}>
				<CardHeader title="Account Balance" />
				<CardContent>
					<div className={classes.balancesWrapper}>
						<div>
							<Typography variant="overline">Available to Spend</Typography>
							<Typography
								style={{
									fontWeight: 800,
									fontSize: '22px',
									lineHeight: '30px',
									color: '#2E7B32'
								}}>
								${(credit / 100).toFixed(2)}
							</Typography>
						</div>
						<div>
							<Typography variant="overline">Pending Charges</Typography>
							<Typography
								style={{
									fontWeight: 800,
									fontSize: '22px',
									lineHeight: '30px',
									color: '#D02C2C'
								}}>
								${(balances && balances.pending ? balances.pending / 100 : 0).toFixed(2)}
							</Typography>
						</div>
						<div>
							<Typography variant="overline">Lifetime Spent</Typography>
							<Typography
								style={{
									fontWeight: 800,
									fontSize: '22px',
									lineHeight: '30px'
								}}>
								${(balances && balances.lifetime ? balances.lifetime / 100 : 0).toFixed(2)}
							</Typography>
						</div>
					</div>
				</CardContent>
				<CardActions>
					<Button
						variant="contained"
						color="secondary"
						onClick={() => setIsChargeAccountDialogShown(true)}>
						Charge Account
					</Button>
					<Button
						variant="outlined"
						color="secondary"
						onClick={() => setIsCreditAccountDialogShown(true)}>
						Add Funds
					</Button>
				</CardActions>
			</Card>
			<ChargeAccountDialog isShown={isChargeAccountDialogShown} setIsShown={setIsChargeAccountDialogShown} />
			<CreditAccountDialog isShown={isCreditAccountDialogShown} setIsShown={setIsCreditAccountDialogShown} />
		</div>
	)
}

export default AccountBalanceCard
